import Commands from './commands';

class SUnion extends Commands {
    constructor(registry) {
        super("sUnion", registry);
    }

    async execute(node, emitter, options) {
        const containerKey = await emitter(node.params[0], options);
        const set1Key = await emitter(node.params[1], options);
        const set2Key = await emitter(node.params[2], options);
        const set1 = this.registry.get(set1Key);
        const set2 = this.registry.get(set2Key);
        if (!set1 || !set2) {
            throw "Union set(s) not defined";
        }
        const containerSet = new Set([...set1, ...set2]);
        this.registry.set(containerKey, containerSet);
        return Array.from(containerSet);
    }
}

export default SUnion;
